import { render, staticRenderFns } from "./movable.vue?vue&type=template&id=790cd14a&scoped=true&"
import script from "./movable.vue?vue&type=script&lang=js&"
export * from "./movable.vue?vue&type=script&lang=js&"
import style0 from "./movable.vue?vue&type=style&index=0&id=790cd14a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790cd14a",
  null
  
)

export default component.exports